import React from "react";
import { Radar } from 'react-chartjs-2';
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
import Explore from "@material-ui/icons/Explore";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import capExResWelcomeStyle from "assets/jss/material-kit-pro-react/views/capabilityExplorerResultsPageSections/capExResWelcomeStyle.jsx";

class CapExResChartSection extends React.Component {
  render() {
    // const chartOptions = {
    //   scale: {
    //     // display: false
    //   },
    //   legend: {
    //     labels: {
    //       fontColor: 'red'
    //     }
    //   }
    // };
    const chartOptions = {
      scales: {
        yAxes: [
          {
            ticks: {
              beginAtZero: true,
              max: 4,
              display: false
            },
            // gridLines: {
            //   drawBorder: true,
            //   display: false
            // }
          }
        ],
        xAxes: [
          {
            barPercentage: 0.4,
              // gridLines: {
              //   drawBorder: true,
              //   display: false
              // }
          }
        ]
      },
    };
    const chartData = {
      labels: [
        "Designing Learning and Teaching",
        "Facilitating and Delivering Learning and Teaching",
        "Optimising Digital Technologies for Learning andTeaching",
        "Transforming Assessment",
        "Transforming the Broader Student Experience",
        "Industry and Academic Collaboration & Currency",
        "Innovating in Learning and Teaching"
      ],
      datasets: [
        {
          label: 'My First dataset',
          backgroundColor: "#007F7B",
          borderColor: 'rgba(179,181,198,1)',
          pointBackgroundColor: 'rgba(179,181,198,1)',
          pointBorderColor: '#fff',
          pointHoverBackgroundColor: '#fff',
          pointHoverBorderColor: 'rgba(179,181,198,1)',
          data: [40, 30, 30, 10, 20, 40, 10],
          // lineTension: 0.2
          // backgroundColor: ["#007F7B"],
        }
      ]
    };
    const { classes } = this.props;
    return (
      <div className={classes.section}>
        <GridContainer>
          <GridItem xs={12} sm={12} md={10}>
            <h2 className={classes.title}>CHART SECTION</h2>
            <h5 className={classes.description}>
              Nice Looking Chart
            </h5>
            <Radar data={chartData} options={chartOptions}></Radar>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

export default withStyles(capExResWelcomeStyle)(CapExResChartSection);
